import React from 'react';
import IconBase, { IconColor, IconSize } from './IconBase';

export type IconFolderOpenProps = {
    color?: IconColor;
    size?: IconSize;
    className?: string;
    title?: string;
};

const IconFolderOpen: React.FC<IconFolderOpenProps> = ({
    color = 'primary',
    size = 'md',
    className = '',
    title = 'Upload file',
}) => (
    <IconBase color={color} size={size} className={className} title={title}>
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="m6 14 1.5-2.9A2 2 0 0 1 9.24 10H20a2 2 0 0 1 1.94 2.5l-1.54 6a2 2 0 0 1-1.95 1.5H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h3.9a2 2 0 0 1 1.69.9l.81 1.2a2 2 0 0 0 1.67.9H18a2 2 0 0 1 2 2v2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </IconBase>
);

export default IconFolderOpen;
